import React from "react";
import { ShortcutUpdateModelv1, ShortcutGroup, defaultShortcut } from "modules/shortcuts/models";
import { Audience } from "modules/audiences";
import ShortcutDialogSkeleton from "./shortcutDialogSkeleton";

interface ICreateShortcutDialogProps {
    show: boolean;
    onClose: () => void;
    onCreateShortcutFromInput: (input: ShortcutUpdateModelv1) => void;
    audiences: Audience[];
    selectedShortcutGroup?: ShortcutGroup;
}

const CreateShortcutDialog: React.FC<ICreateShortcutDialogProps> = ({
    show,
    onClose,
    onCreateShortcutFromInput,
    audiences,
    selectedShortcutGroup
}) => {
    return <ShortcutDialogSkeleton
        show={show}
        onClose={onClose}
        onDialogActionButtonClick={onCreateShortcutFromInput}
        audiences={audiences}
        dialogTitle="Create New Shortcut"
        dialogActionButtonLabel="Create"
        input={{...defaultShortcut, groupId: selectedShortcutGroup?.id ?? defaultShortcut.groupId}}
    />;
};

export default CreateShortcutDialog;
